import React from 'react';
import {
  Instagram,
  Facebook,
  Twitter,
  Linkedin,
  Youtube,
  Heart,
} from 'lucide-react';
import logo from '../assets/Inz_logo.png';
import { useNavigate } from 'react-router-dom';

export const Footer = () => {
  const navigate = useNavigate();
  const openPolicy = (type) => {
    switch (type) {
      case '/terms':
        navigate('/terms');
        break;
      case '/refund':
        navigate('/refund');
        break;
      case '/privacy':
        navigate('/privacy');
        break;
      default:
        break;
    }
  };

  // ✅ Social links with real URLs
  const socialLinks = [
    {
      icon: Instagram,
      href: 'https://www.instagram.com/yourpage', // Replace with real link
      label: 'Instagram',
    },
    {
      icon: Facebook,
      href: 'https://www.facebook.com/yourpage', // Replace with real link
      label: 'Facebook',
    },
    {
      icon: 'whatsapp', // handled separately below
      href: 'https://wa.me/919000000000', // Replace with your WhatsApp number
      label: 'WhatsApp',
    },
  ];

  return (
    <footer className="bg-white border-t border-gray-200 py-8 mt-12">
      <div className="max-w-md mx-auto px-4 text-center">



        {/* --- Elegant Social Icons --- */}
        <div className="flex justify-center gap-6 mb-6">
          {/* Instagram */}
          <a
            href="https://www.instagram.com/aaladipattiyan_official"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-pink-500 transition-colors duration-200"
          >
            <Instagram size={24} />
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/tirunelvelihalwakadai"
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
          >
            <Facebook size={24} />
          </a>

          {/* WhatsApp */}
          {/* <a
            href="https://wa.me/919000000000" // your WhatsApp number
            aria-label="WhatsApp"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-green-600 transition-colors duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M20.52 3.48A11.8 11.8 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.55 4.17 1.6 5.98L0 24l6.29-1.64A11.96 11.96 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.18-3.48-8.52ZM12 22a9.93 9.93 0 0 1-5.1-1.39l-.36-.21-3.73.97.99-3.64-.23-.37A10 10 0 1 1 12 22Zm5.61-7.31c-.31-.16-1.82-.9-2.1-1.01-.28-.1-.48-.16-.68.16-.2.31-.78 1.01-.95 1.21-.17.2-.35.23-.66.08-.31-.16-1.29-.48-2.46-1.54-.91-.81-1.52-1.81-1.69-2.11-.17-.31-.02-.48.13-.63.13-.13.31-.35.46-.52.16-.17.2-.29.31-.48.1-.2.05-.37-.03-.52-.08-.16-.68-1.62-.93-2.21-.24-.58-.49-.5-.68-.5h-.58c-.2 0-.52.07-.79.37-.27.31-1.04 1.01-1.04 2.48s1.07 2.88 1.22 3.08c.16.2 2.11 3.23 5.11 4.53.71.31 1.26.49 1.69.63.71.23 1.35.2 1.86.12.57-.09 1.82-.74 2.08-1.45.26-.71.26-1.32.18-1.45-.08-.12-.28-.2-.58-.36Z" />
            </svg>
          </a> */}
        </div>

        {/* --- Policy Links --- */}
        <div className="flex flex-wrap justify-center gap-4 mb-2">
          <button
            type="button"
            onClick={() => openPolicy('/privacy')}
            className="underline text-gray-600 hover:text-gray-800"
          >
            Privacy Policy
          </button>
          <button
            type="button"
            onClick={() => openPolicy('/terms')}
            className="underline text-gray-600 hover:text-gray-800"
          >
            Terms & Conditions
          </button>
          <button
            type="button"
            onClick={() => openPolicy('/refund')}
            className="underline text-gray-600 hover:text-gray-800"
          >
            Refund & Cancellation
          </button>
          <button
  type="button"
  onClick={() => window.open("https://halwakadai.com/outlets", "_blank")}
  className="underline text-gray-600 hover:text-gray-800"
>
  Outlets
</button>
        </div>
        {/* --- Brand attribution --- */}
        <p className="text-xs text-gray-500 flex items-center justify-center gap-1 mb-1">
          Made with <Heart size={12} className="text-red-500" /> in partnership with{' '}
          <a
            href="https://www.inzpire.in"
            className="text-blue-600 font-semibold hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Inzpire Solutions
          </a>
        </p>

        <p className="text-center text-sm text-gray-500 mt-1">
          © 2025 Aaladipattiyan Private Limited
        </p>
      </div>
    </footer>
  );
};
